import React, { useEffect, useState } from "react";
import { Container, Row,Spinner } from "react-bootstrap";
// import { Link } from "react-router-dom";
import Dashboard from "../components/MerchantDashboard";
import ReviewContainer from "../components/ReviewContainer";
import CustomHelmet from "../components/CustomHelmet";
import axios from "axios";

const url =
  "https://www.hubsquares.com/php_files/fetchListingOwner.php/";
const Reviews = ({ user }) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchListing = async () => {
      await axios.post(url, { owner: user }).then((res) => {
         setListings(res.data.listing);
        setLoading(false);
      });
    };
    fetchListing();
  }, [user]);
  // console.log(review);
  return (
    <>
      <CustomHelmet page="Reviews" />
      <Dashboard user={user} page="My Reviews">
        <Container className="my-3">
        {loading ? (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : (
            listings  ? (
                 <Row>
                 {listings.map((lis) => (
                   <ReviewContainer
                     img={`https://www.hubsquares.com/php_files/covers/${lis.cover}`}
                     title={lis.title}
                     business={lis.category}
                     key={lis.refID}
                     refID={lis.refID}
                   />
                 ))}
               </Row>
            ) : (
              <h5>You have no business to review</h5>
          )
          )}
            
        </Container>
      </Dashboard>
    </>
  );
};
export default Reviews;
